import {
  IconButton as MatIconButton,
  IconButtonProps as MatIconButtonProps,
  SvgIconProps,
  Typography,
} from "@mui/material"

import React, { FC } from "react"

import { create } from "src/helpers/bem"

import styles from "./IconButton.module.scss"

export type IconButtonProps = {
  title?: string
  icon: React.FC<SvgIconProps>
} & MatIconButtonProps

const bem = create(styles, "IconButton")

export const IconButton: FC<IconButtonProps> = ({ ...props }) => (
  <MatIconButton {...props} className={bem("element")}>
    <props.icon fontSize="large" />
    <Typography className={bem("label")} fontWeight="700" variant="button">
      {props.title}
    </Typography>
    {props.children}
  </MatIconButton>
)
